import { initTabs } from '../modules/tabs';
import { initAjaxList } from '../modules/ajax-list';
import { initAjaxTable } from '../modules/ajax-table';
import { initAjaxGlossary } from '../modules/ajax-glossary';
import { initCarousel } from '../modules/slider';
import { showAlerts } from '../modules/alert';
import { header } from '../modules/header';
import { initCta } from '../modules/cta';
import { initAccordion } from '../modules/accordion';
import { initForm } from '../modules/forms';
import { submitSearchForm } from '../pages/search';
import { initGuidedSearch, initGuidedSearchPersona } from '../modules/guided-search';
import { copyLink } from '../modules/share-list';
import { initSections } from '../modules/sections';
import { initTextModule } from '../modules/text';
import { initSingleMitigation } from '../pages/single-mitigation';
import { initSingleHigherStandard } from '../pages/single-higher-standard';

export default {
  init() {
    // JavaScript to be fired on all pages
    showAlerts();
  },
  finalize() {
    initTabs();
    initAjaxList();
    initAjaxTable();
    initAjaxGlossary();
    initCarousel();
    header();
    initCta();
    initAccordion();
    initForm();
    submitSearchForm();
    initGuidedSearch();
    initGuidedSearchPersona();
    copyLink();
    initSections();
    initTextModule();
    initSingleMitigation();
    initSingleHigherStandard();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js